var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rounded-full h-9 w-9",attrs:{"src":_vm.profilePictureURL,"alt":"Gravatar Profile Picture"}})}
var staticRenderFns = []

export { render, staticRenderFns }